// extracted by mini-css-extract-plugin
export default {"WorkTime":"Employee_WorkTime__Ux9Ic","CountZones":"Employee_CountZones__Q5puP"};